import styled, { css } from 'styled-components';

export const RadioWrapper = styled.div(
  ({ theme: { spacers, admanColors } }) => css`
    .TrekRadio-root .TrekRadio-checked::after {
      background: ${admanColors!.blue.dark.bg1[0]};
    }

    div.TrekRadio-root {
      padding-left: ${spacers!.spacer05};
    }

    label.TrekRadio-root {
      border: 1px solid ${admanColors!.blue.dark.bg1[0]};
    }

    .TrekRadio-label {
      font-size: 14px;
      font-family: InspireTWDC;
    }
  `
);
